import { PropsWithChildren } from 'react';
import classNames from 'classnames';

import { SCROLL_COMPONENT_ID } from '~/config';
import TutorialButton from '~/routes/LootBoyContainer/TutorialButton';

import Footer from './Footer';
import TopNavigationBar from './TopNavigationBar';

import style from './LootboyContainer.module.scss';

interface ILootBoyContainerProps {
  shouldRenderFooter?: boolean;
}

function LootBoyContainer({
  children,
  shouldRenderFooter = true,
}: PropsWithChildren<ILootBoyContainerProps>): JSX.Element {
  return (
    <div className={classNames(style.lootboyContainer, 'lootBoycontainer')}>
      <TopNavigationBar />
      <div
        className={style.lootboyScroll}
        id={SCROLL_COMPONENT_ID}
      >
        <div className={style.lootboyContent}>{children}</div>
        {shouldRenderFooter && <Footer />}
      </div>
      <TutorialButton />
    </div>
  );
}

export default LootBoyContainer;
